import axiosPrivateMl from "@services/axiosPrivateMl"
import { GROUP_CREATIVES_FROM_FOLDER_URL } from "../../constants"

export const groupCreativesFromFolderUrl = (data) => {
  return axiosPrivateMl.post(GROUP_CREATIVES_FROM_FOLDER_URL, data)
}
